import React, { Component } from "react";
import "./NavMenu.css";

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  render() {
    return null;
  }
}
